import { useMediaQuery } from 'react-responsive'
import { atom } from 'recoil'

export const clientIsMobile = atom<boolean>({
  key: 'clientIsMobile',
  default: true,
})
